'use strict';
import * as $j_com$002eraquo$002elaminar$002ereceivers$002e$002dChild$002dReceiver$0024 from "./com.raquo.laminar.receivers.-Child-Receiver$.js";
import * as $j_com$002eraquo$002elaminar$002ereceivers$002e$002dChildren$002dReceiver$0024 from "./com.raquo.laminar.receivers.-Children-Receiver$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_Lcom_raquo_laminar_api_Laminar__$init$__V($thiz) {
  $thiz.R6 = $j_com$002eraquo$002elaminar$002ereceivers$002e$002dChild$002dReceiver$0024.$m_Lcom_raquo_laminar_receivers_ChildReceiver$();
  $thiz.R7 = $j_com$002eraquo$002elaminar$002ereceivers$002e$002dChildren$002dReceiver$0024.$m_Lcom_raquo_laminar_receivers_ChildrenReceiver$();
}
export { $f_Lcom_raquo_laminar_api_Laminar__$init$__V as $f_Lcom_raquo_laminar_api_Laminar__$init$__V };
